import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { getLanguage } from "../Managers/dataProvider";
import { BranchReportModel } from "../Managers/dataStructures";
import { Table, TH, TD, TR } from "../../../AuxComponents/";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    //backgroundColor: "#E4E4E4",
    backgroundColor: "#FFFFFF",
  },
  header: {
    backgroundColor: "#FFFFFF",
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
  },
  table: {
    marginTop: "25px",
  },
  tableHeader: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
  tableCell: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
});

interface PDFReportAllBranchProps {
  startDateString: string;
  endDateString: string;
  array_reports: BranchReportModel[];
}

export default function PDFReportAllBranch(props: PDFReportAllBranchProps) {
  const isEnglish = getLanguage();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View>
            <View>
              <Text style={styles.title}>
                {isEnglish ? "Report : All Branches" : ""}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "From : " : "Von : ") + props.startDateString}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "To : " : "Bis : ") + props.endDateString}
              </Text>
            </View>
            <View></View>
            <View style={styles.table}>
              <Table>
                <TH>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Branch" : "Filiale"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Total Hours" : "Gesamtarbeitsstunden"}
                    </Text>
                  </TD>
                </TH>
                {props.array_reports.map((x) => CellReportDetail(x))}
              </Table>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

function CellReportDetail(item: BranchReportModel) {
  return (
    <TR key={item.branch.branch_id}>
      <TD>
        <Text style={styles.tableCell}>{item.branch.name}</Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>{item.working_hours}</Text>
      </TD>
    </TR>
  );
}
